import cn from "classnames"
import { MouseEvent } from "react"

import { Lang } from "utils/interfaces"
import { PSYALTER_SUPPORT_EMAIL, PSYALTER_SUPPORT_TELEGRAM } from "utils/env-management"

interface LinkProps {
    text: string
    href: string
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void
}

function Link({ text, href, onClick }: LinkProps) {
    return (
        <a
            target="_blank"
            rel="noopener noreferrer"
            href={href}
            className="support-description__link"
            onClick={onClick}
        >
            {text}
        </a>
    )
}

interface Props {
    className?: string
    lang: Lang
    onClickMail?: (event: MouseEvent<HTMLAnchorElement>) => void
    onClickTelegram?: (event: MouseEvent<HTMLAnchorElement>) => void
}

export function SupportDescription({ className, lang, onClickMail, onClickTelegram }: Props) {
    const text = lang === "ru" ? "Служба поддержки" : "Support"
    const email = lang === "ru" ? "Почта" : "Email"
    const telegram = lang === "ru" ? "Телеграм" : "Telegram"
    const description =
        lang === "ru" ? "Напишите нам по\u00a0любым вопросам." : "Ask us any questions."
    const workingHours =
        lang === "ru"
            ? "Мы\u00a0работаем с\u00a010:00 до\u00a020:00\u00a0Мск, стараемся\nотвечать в\u00a0тот\u00a0же день."
            : "Working\u00a0hours: 10am—10pm\u00a0UTC+3.\nWe try reply on the same day."

    return (
        <div className={cn("support-description", className)}>
            <div className="support-description__headline">{text}</div>
            {description}
            <ul className="support-description__list">
                <li className="support-description__item">
                    {email}:
                    <Link
                        text={PSYALTER_SUPPORT_EMAIL}
                        href={"mailto:" + PSYALTER_SUPPORT_EMAIL}
                        onClick={onClickMail}
                    />
                </li>
                <li className="support-description__item">
                    {telegram}:
                    <Link
                        text="@psyalter_bot"
                        href={PSYALTER_SUPPORT_TELEGRAM}
                        onClick={onClickTelegram}
                    />
                </li>
            </ul>
            <div className="support-description__bottom">{workingHours}</div>
        </div>
    )
}
